/** @format */
import { ChangeDetectionStrategy, Component, input, InputSignal, ViewEncapsulation } from '@angular/core';
import { CartWizardContainerComponent } from '../cart-wizard-container.component';

/**
 * Level 2 heading showing the current wizard step's name, prefixed with its order number.
 * Use inside a {@link CartWizardContainerComponent}.
 */
@Component({
    selector: 'app-cart-wizard-step-heading',
    standalone: false,
    templateUrl: './cart-wizard-step-heading.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartWizardStepHeadingComponent {
    /**
     * Translation keys of the shown wizard steps.
     */
    readonly wizardStepKeys: InputSignal<readonly string[]> = input.required();

    /**
     * Zero-based index of the selected step in {@link wizardStepKeys}.
     */
    readonly currentWizardStepIndex: InputSignal<number> = input.required();
}
